import { render, staticRenderFns } from "./FPTemp1.vue?vue&type=template&id=24936f52&scoped=true&"
import script from "./FPTemp1.vue?vue&type=script&lang=js&"
export * from "./FPTemp1.vue?vue&type=script&lang=js&"
import style0 from "./FPTemp1.vue?vue&type=style&index=0&id=24936f52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24936f52",
  null
  
)

export default component.exports